<template>
    <div class="scroll-content">
        <div class="item-scroll">
            <div class="items" ref="pickerItems" @touchstart="start" @touchmove="move" @touchend="end" @touchmove.prevent>
                <div class="item themeText ellipsis" v-for="(item, index) in columns" :key="index" @click="setChoose(index)">{{item.name}}</div>
            </div>
        </div>
        <div class="pick-mask" ref="pickMask">
            <div class="mask-item"></div>
            <div class="mask-item"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        index: Number,
        data: Array,
    },
    data() {
        return {
            pickerIndex: this.index,
            columns: this.data,
            
            
            isMove: false,
            startY: 0,
            translateY: 76,
            moveTranslateY: 0,
            pickerItems: null,
        }
    },
    watch: {
        index(val) {
            this.pickerIndex = val
            // 保证外部改变 index 时立即更新显示
            this.$nextTick(() => {
                this.setChoose(typeof val === 'number' ? val : 0)
            })
        },
        data(val) {
            this.init();
        },
        pickerIndex(val) {
            this.$emit("update:index", val);
        }
    },
    mounted() {
        this.init();
        
    },
    methods: {
        init() {
            this.columns = this.data
            this.pickerItems = this.$refs.pickerItems;
            this.$nextTick(() => {
                this.setChoose(this.pickerIndex || 0);
            })
        },
        start(e) {
            this.setMove(e, 'start')
        },
        move(e) {
            this.setMove(e, 'move')
        },
        end(e) {
            this.setMove(e, 'end')
        },

        setMove(e, type) {
            var touch = e.targetTouches[0] || {}, pageY = touch.pageY, moveY, translateY, chooseIndex;
            var overEnd = this.columns.length * -40 + 76;
            if(type == 'start') {
                this.startY = pageY;
            }else if(type == 'end') {
                if(!this.isMove) return;
                this.isMove = false;
                this.translateY = this.moveTranslateY;
                moveY = (this.pickerIndex * -40 + 76) - this.moveTranslateY;
                var index = this.pickerIndex + parseInt(moveY / 40);
                if((moveY % 40) != 0) {
                    index = moveY > 0? index + 1 : index - 1;
                }
                if(index < 0) {
                    index = 0;
                }else if (index >= this.columns.length) {
                    index = this.columns.length - 1
                }
                // return;
                this.setChoose(index);
            }else {
                this.isMove = true;
                moveY = pageY - this.startY;
                translateY = moveY + this.translateY;
                if(translateY >= 116) translateY = 116;
                if(translateY <= overEnd) translateY = overEnd;
                this.moveTranslateY = translateY;
                this.pickerItems.style = `transform: translate3d(0px, ${this.$utils.pt(translateY)}, 0px);transition-duration: 0ms;transition-property: none;`;
            }
        },

        setChoose(index) {
            console.log(index)
            this.pickerIndex = index;
            this.translateY = index * -40 + 76;
            // 如果 pickerItems 尚未挂载，延后执行样式设置
            if(!this.pickerItems) {
                this.$nextTick(() => {
                    this.pickerItems = this.$refs.pickerItems;
                    if(this.pickerItems) {
                        this.pickerItems.style = `transform: translate3d(0px, ${this.$utils.pt(this.translateY)}, 0px);transition-duration: 200ms;transition-property: all;`;
                    }
                })
                return;
            }
            this.pickerItems.style = `transform: translate3d(0px, ${this.$utils.pt(this.translateY)}, 0px);transition-duration: 200ms;transition-property: all;`;
        },
    }
}
</script>

<style lang="scss" scoped>
    .scroll-content {
        padding: 28px 0;
        height: 177px;
        overflow: auto;
        position: relative;
        width: 100%;
        
        &::-webkit-scrollbar {
            display: none
        }

        .item-scroll {
            overflow: hidden;
            height: 40px;
            height: 76px;
            height: 100%;

            &::-webkit-scrollbar {
                display: none
            }
        }

        .items {

            .item {
                font-size: 18px;
                line-height: 25px;
                color: #E22F25;
                margin-top: 15px;

                &:first-child {
                    margin-top: 0;
                }
            }
        }

        .pick-mask {
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            height: 100%;
            position: absolute;
            pointer-events: none;

            .mask-item {
                height: 95px;
                // background: rgba(0,0,0,0.3);
                background-image: -webkit-linear-gradient(top, hsla(0, 0%, 100%, 0.3), hsla(0, 0%, 100%, 0.3)), -webkit-linear-gradient(bottom, hsla(0, 0%, 100%, 0.3), hsla(0, 0%, 100%, 0.3));
                background-image: linear-gradient(180deg, hsla(0, 0%, 100%, 0.3), hsla(0, 0%, 100%, 0.3)), linear-gradient(0deg, hsla(0, 0%, 100%, 0.3), hsla(0, 0%, 100%, 0.3));
                background-repeat: no-repeat;
                background-position: top, bottom;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                pointer-events: none;
                background-size: 100% 68px;
                backdrop-filter: grayscale(1);

                &:first-child {
                    border-bottom: 1px solid #EEEEEE;
                }

                &:last-child {
                    border-top: 1px solid #EEEEEE;
                    position: relative;
                    top: 41px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/base/picker-scroll.vue